// extracted by mini-css-extract-plugin
export default {"root":"Select_root__obbFe","control":"Select_control__0tMgc","icon":"Select_icon__8fo97"};